import { ServiceAuditorDisplayStatus } from '@commenda/api/agent-platform/service-auditor/types';
import { TWorkflowExecution } from '@commenda/types';
import { TaskParty, TaskStatus } from '@prisma/client';

import { TaskStepIndicator } from '../../layout/tabs/components/timeline/TaskStepIndicator';
import { ServiceAuditRunStatusHelper } from '../helpers/ServiceAuditRunStatusHelper';
import { useServiceAuditStepStatus } from '../hooks/useServiceAuditStepStatus';

interface IServiceAuditTimelineIndicatorProps {
  auditorStepId: string;
  role: TaskParty;
  workflowExecution: TWorkflowExecution | undefined;
  taskStatus: TaskStatus;
  isCurrent: boolean;
}

/** Timeline dot of an auditor step or its wait step, following the newest audit instead of the task status. */
export const ServiceAuditTimelineIndicator = ({
  auditorStepId,
  role,
  workflowExecution,
  taskStatus,
  isCurrent,
}: IServiceAuditTimelineIndicatorProps) => {
  const { auditStatus, isLoading, error } = useServiceAuditStepStatus({
    auditorStepId,
    role,
    workflowExecution,
  });
  const shownAuditStatus = isLoading || error ? null : auditStatus;

  return (
    <TaskStepIndicator
      status={ServiceAuditRunStatusHelper.getAuditTaskStatus(
        shownAuditStatus,
        taskStatus
      )}
      isCurrent={isCurrent}
      isFailed={shownAuditStatus === ServiceAuditorDisplayStatus.FAILED}
    />
  );
};
